import React, { Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './shared/components/loading/loading.css'
import App from './App'
import ThemedSuspense from './shared/components/ThemedSuspense'
import { Windmill } from '@windmill/react-ui'
import * as serviceWorker from './serviceWorker'
import { ThemeProvider, useTheme } from './context/ThemeContext'
import checkApiBaseUrl from './config/checkApiBaseUrl'

// Diagnose a misconfigured API base URL up front (dev only). Catches the
// localhost-vs-other-device and http-API-on-https-page cases, which otherwise
// only appear as a generic "network error" on every data-loading route.
checkApiBaseUrl()

/**
 * AppWrapper connects our global ThemeContext to the Windmill UI library.
 * By passing the 'dark' prop directly to Windmill based on our theme state,
 * we ensure that Windmill's internals always follow our single source of truth.
 * We disable Windmill's 'usePreferences' to prevent it from managing its own
 * separate theme state in localStorage.
 */
function AppWrapper() {
  const { theme } = useTheme();

  return (
    <Windmill usePreferences={false} dark={theme === 'dark'}>
      <App />
    </Windmill>
  );
}

const root = createRoot(document.getElementById('root'))
root.render(
  <Suspense fallback={<ThemedSuspense />}>
    <ThemeProvider>
      <AppWrapper />
    </ThemeProvider>
  </Suspense>
)

serviceWorker.unregister()
